import { IconFileDescription, IconUpload, IconEdit, IconTrash, IconReload } from '@tabler/icons-react';
import { NavigateFunction } from 'react-router-dom';
import { AfaTableColumn } from '../components/ui/AfaTable/AfaTable';
import { AfaAnchor } from '../components/ui/AfaAnchor';
import { AfaMenu } from '../components/ui/AfaMenu';
import moment from 'moment';

interface TramitsTableHandlers {
  onCancelTramit: (tramitId: string) => void;
  onDeleteDraft: (tramitId: string) => void;
}

/**
 * Configuración de columnas para la tabla de Tramits
 * Esta función retorna la configuración completa de las columnas de la AfaTable
 * 
 * @param navigate - Función de navegación de React Router
 * @param handlers - Handlers para acciones de la tabla
 * @returns Array de configuración de columnas para AfaTable
 */
export function getTramitsColumns(
  navigate: NavigateFunction,
  handlers: TramitsTableHandlers,
  userMail: any
): AfaTableColumn[] {
  return [
    // {
    //   key: 'alert',
    //   title: '',
    //   type: 'text',
    //   width: 40,
    //   render: () => (
    //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    //       <Tooltip label="Alert text" position="top" withArrow>
    //         <IconAlertTriangle size={20} color="var(--mantine-color-yellow-5)" />
    //       </Tooltip>
    //     </div>
    //   )
    // },
    {
      key: 'guid',
      title: 'ID',
      type: 'text',
      width: 150,
      render: (value, row) => (
        <AfaAnchor
          href="#"
          size="md"
          onClick={e => {
            e.preventDefault();
            navigate(`/tramits/detall/${row.id}`);
          }}
        >
          {value}
        </AfaAnchor>
      )
    },
    {
      key: 'filial.lookupValue',
      title: 'Filial',
      type: 'text',
      width: 50,
    },
    {
      key: 'processType',
      title: 'Tipus de procés',
      type: 'text',
      width: 80,
    },
    {
      key: 'tramitType.lookupValue',
      title: 'Procés',
      type: 'text',
      width: 300,
    },
    {
      key: 'relatedTramits',
      title: 'Procès anterior',
      type: 'text',
      width: 150,
      render: (value) => {
        if (!value || !value.lookupValue) {
          return; // Muestra un guion o mensaje vacío
        }
        return (
          <AfaAnchor
            href="#"
            size="md"
            onClick={e => {
              e.preventDefault();
              navigate(`/tramits/detall/${value.lookupId}`);
            }}
          >
            {value.lookupValue}
          </AfaAnchor>
        )
      }
    },
    {
      key: 'registerDate',
      title: 'Data de presentació',
      type: 'text',
      width: 100,
      render: (value) => {
        const date = moment(value);
        if (!date.isValid() || date.year() <= 1900) {
          return null;
        }
        return date.format('YYYY-MM-DD HH:mm');
      }
    },
    {
      key: 'state',
      title: 'Estat',
      type: 'badge',
      width: 80,
      badgeConfig: {
        colorMap: {
          'En revisió': 'yellow',
          'Pendent rebre documentació': 'orange',
          'Cancel·lat entitat': 'lilac',
          'Rebutjat AFA': 'red',
          'Finalitzat': 'green',
          'Esborrany': 'blue',
          'Pendent rebre pagament': 'blue'
        }
      }
    },
    {
      key: 'createdBy.lookupValue',
      title: 'Creada per',
      type: 'text',
      width: 100,
    },
    {
      key: 'accions',
      title: '',
      type: 'menu',
      width: 40,
      render: (value, row) => {
        const menuItems = [];

        //console.log(row.nextTramitType)
        //console.log('----------')

        menuItems.push({
          label: 'Veure Detall',
          icon: <IconFileDescription />,
          onClick: () => navigate(`/tramits/detall/${row.id}`)
        });

        if(row.nextTramitType != null){

          menuItems.push(
            {
              label: 'Continuar procès',
              icon: <IconReload />,
              onClick: () =>
              navigate(`/tramits/iniciar-nou`, {
                state: {
                  tramitType: row.nextTramitType,
                  idType: row.id,
                  from: 'editar',
                },
              })
            })
        }
        if (row.state == 'Esborrany') {
          menuItems.push(
            {
              label: 'Editar',
              icon: <IconEdit />,
              onClick: () => navigate(`/tramits/editar/${row.id}`)
            })
          if (row.createdBy != null && row.createdBy.lookupId != -1 && row.createdBy.lookupValue === userMail.user.titulo) {
            menuItems.push({
              label: 'Esborrar',
              icon: <IconTrash />,
              color: 'red',
              onClick: () => handlers.onDeleteDraft(row.id)
            });
          }
        }
        else {
          switch (row.fase) {
            case 'Validació i Anàlisi':
              menuItems.push(
                {
                  label: 'Enviar documentació',
                  icon: <IconUpload />,
                  onClick: () => navigate(`/tramits/detall/${row.id}?sendDocs=true`)
                },
                {
                  label: 'Cancel·lar',
                  icon: <IconTrash />,
                  color: 'red',
                  onClick: () => handlers.onCancelTramit(row.id)
                }
              );
              break;
            case 'Rebre pagament':
              menuItems.push({
                label: 'Enviar documentació',
                icon: <IconUpload />,
                onClick: () => navigate(`/tramits/detall/${row.id}?sendDocs=true`)
              });
              break;

            case 'Pendent rebre documentació':
              menuItems.push({
                label: 'Enviar documentació',
                icon: <IconUpload />,
                onClick: () => navigate(`/tramits/detall/${row.id}?sendDocs=true`)
              });
              break;

            default:
              break;
          }
        }

        return <AfaMenu variant="filled" items={menuItems} />;
      }
    }
  ];
}
